// Registrační seznamy agend modulu VenuaPlanner — konzumuje je centrální registr native agend
// (`app/router/nativeAgendaRegistry`) pro globální registraci v kernelu (agendy nemají vlastní route).

import type { AgendaRegistration } from '@/shared/navigation';

import { venuaPlannerAgenda } from './venuaPlannerAgenda';
import { VenuaPlannerShellPage } from './VenuaPlannerShellPage';
import { projectFormAgenda, ProjectFormPage } from './project';
import {
  serieFormAgenda,
  SerieFormPage,
  serieDetailAgenda,
  SerieDetailPage,
  termDetailAgenda,
  TermDetailPage,
} from './serie';
import {
  productFormAgenda,
  ProductFormPage,
  productDetailAgenda,
  ProductDetailPage,
} from './product';
import {
  placeholderListAgenda,
  PlaceholderListPage,
  placeholderDetailAgenda,
  PlaceholderDetailPage,
  subcategoryListAgenda,
  SubcategoryListPage,
  subcategoryDetailAgenda,
  SubcategoryDetailPage,
} from './schemes';
import {
  VENUA_PLANNER_PERMISSION,
  VENUA_PLANNER_PLACEHOLDERS,
  VENUA_PLANNER_PLACEHOLDER_SUBCATEGORIES,
} from './permissions';

/**
 * Agendy slice VenuaPlanner (route `/venua-planner`) — root tree (kalendářový i plánovací režim)
 * + zakládací/detail agendy.
 */
export const venuaPlannerAgendas: AgendaRegistration[] = [
  {
    agenda: venuaPlannerAgenda,
    component: VenuaPlannerShellPage,
    permission: VENUA_PLANNER_PERMISSION,
  },
  { agenda: projectFormAgenda, component: ProjectFormPage, permission: VENUA_PLANNER_PERMISSION },
  { agenda: productFormAgenda, component: ProductFormPage, permission: VENUA_PLANNER_PERMISSION },
  { agenda: serieFormAgenda, component: SerieFormPage, permission: VENUA_PLANNER_PERMISSION },
  {
    agenda: productDetailAgenda,
    component: ProductDetailPage,
    permission: VENUA_PLANNER_PERMISSION,
  },
  { agenda: serieDetailAgenda, component: SerieDetailPage, permission: VENUA_PLANNER_PERMISSION },
  { agenda: termDetailAgenda, component: TermDetailPage, permission: VENUA_PLANNER_PERMISSION },
];

/** Agendy „Knihovna placeholderů" (route `/placeholders`) — seznam + detail overlay. */
export const venuaPlannerPlaceholderAgendas: AgendaRegistration[] = [
  {
    agenda: placeholderListAgenda,
    component: PlaceholderListPage,
    permission: VENUA_PLANNER_PLACEHOLDERS,
  },
  {
    agenda: placeholderDetailAgenda,
    component: PlaceholderDetailPage,
    permission: VENUA_PLANNER_PLACEHOLDERS,
  },
];

/** Agendy „Subkategorie placeholderů" (route `/placeholder-subcategories`) — seznam + detail overlay. */
export const venuaPlannerPlaceholderSubcategoryAgendas: AgendaRegistration[] = [
  {
    agenda: subcategoryListAgenda,
    component: SubcategoryListPage,
    permission: VENUA_PLANNER_PLACEHOLDER_SUBCATEGORIES,
  },
  {
    agenda: subcategoryDetailAgenda,
    component: SubcategoryDetailPage,
    permission: VENUA_PLANNER_PLACEHOLDER_SUBCATEGORIES,
  },
];
